import { IsOptional, IsInt, Min } from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'
import { Type } from 'class-transformer'

/**
 * DTO for batch stats calculation
 */
export class BatchCalculateStatsDto {
  @ApiPropertyOptional({
    description: 'Limite du nombre d\'activités à calculer',
    example: 100,
    default: 100,
  })
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  limit?: number = 100
}








